import map    from './map'
import places from './places'

export default
{
    map,
    places
};
